<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="signOut()" class="power">
      <i style="cursor: pointer; font-size: 0.5rem" class="el-icon-back"></i>
    </div>
    <!-- <div class="otherReport">
      <img @click="d8Process()" style="height: 0.6rem" src="../../../assets/img/fr/table.png" />
    </div> -->
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <el-button class="title" type="primary">{{ title }}</el-button> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "5WHY" }}
      </div>
    </header>
    <div style="height: 100vh;width:100%">


      <el-row :gutter="0">
        <!--第一列-->
        <el-col :span="24">
          <el-row :gutter="4">
            <el-col :span="24">
              <div style="height: 20vh" id="id1" @click="showTab('id1')">
                <!--d1-->
                <d1-component :bean="d8Data" />
              </div>
            </el-col>
            <el-col :span="24">
              <div style="height: 60vh" id="id2" @click="showTab('id2')">
                <!--d2-->
                <d2-component :bean="d8Data" />
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="elDialog">
      <!--表格预览-->
      <el-dialog width="85%" :visible.sync="tempShow">
        <div style="height: 60vh;color:white">
          <div v-html="innerHTML"></div>
        </div>
      </el-dialog>

      <!--图片预览-->
      <el-dialog width="65%" :visible.sync="viewShow" title="图片预览">
        <div style="height: 60vh;color:white">
          <el-carousel tyle="border:0px;" height="50vh" :interval="5000" arrow="always">
            <el-carousel-item v-for="item in viewImg" :key="item">
              <img style="width: 100%;height:100%;object-fit: cover" :src="item" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-dialog>

      <el-dialog width="65%" :visible.sync="todoShow" title="待办事项">
        <div style="height: 50vh;border: 1px solid #CCCCCC;border-radius: 5px;color:white">
          <div v-html="d8Data['toStr']"></div>
        </div>
      </el-dialog>

      <el-dialog width="60%" :visible.sync="d8Show" title="D8">
        <div style="height: 60vh;border: 1px solid #CCCCCC;border-radius: 5px;">
          <img style="width: 100%;height:100%;object-fit: cover" src="../../../assets/img/fr/team.jpg" />
        </div>
      </el-dialog>
    </div>

  </div>
</template> 

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
import d2Component from "./component/2d.vue";
import d1Component from "./component/1d.vue";
export default {
  name: "App",
  components: {
    d2Component,
    d1Component,
  },
  data() {
    return {
      d8Show: false,
      viewShow: false,
      todoShow: false,
      tempShow: false,
      websock: null,
      lockReconnect: false,
      reconnectData: null,
      isload: false,
      d8Data: {},
      viewImg: [],
      now: null,
      week: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "5WHY",
      productList: [],
      product: {},
      productUUID: null,
      innerHTML: null,
      reportFile: ''
    };
  },

  mounted() {
    this.startLoading();
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    setInterval(this.clock, 1000);
  },
  created() {
    this.isload = true;
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    dowReport() {
      if (!this.d8Data.reportFile) {
        this.$message.success("还未上传8D报告!");
        return;
      }
      window.open(this.d8Data.reportFile, '_blank');
    },
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    showTab(id) {
      if (id == 'id5') {
        this.viewShow = true;
        this.viewImg = this.d8Data['fishboneDiagram'] || [];
      } else if (id == 'idr') {
        this.viewShow = true;
        this.viewImg = this.d8Data['images'] || [];
      } else if (id == 'id7') {
        var doc = document.getElementById(id).innerHTML;
        this.innerHTML = doc.replaceAll("20vh", "60vh");
        this.tempShow = true;
      } else {
        var doc = document.getElementById(id).innerHTML;
        this.innerHTML = doc.replaceAll("20vh", "60vh");
        this.tempShow = true;
      }
    },
    signOut() {
      router.back();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadTemplateCategory() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadTemplateCategory()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },
    selectProduct(item) {
      this.product = item || {};
      this.productUUID = item ? item.uuid : null;
      this.isload = true;
      this.loadData();
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var issueUUID=this.$route.query.key;
        if(!issueUUID){
            return;
        }
        var params = {"issueId":issueUUID};

        API.whyReport(params)
          .then((res) => {
            this.endLoading();
            if (res.success === true) {
              this.d8Data = res["value"] || {};
            }
          })
          .catch((error) => {
            console.log(error);
            this.endLoading();
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/fr/issue/deep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/deep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Fr socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Fr socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("Fr socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.elDialog .el-dialog {
  background-color: #003246;
}

.elDialog .el-dialog__title {
  color: white;
}

.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}

.pagebg {
  background: url("../../../assets/img/8dbg.png");
}

/* .p {
  padding: 0rem 0.2rem;
} */

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
</style>
<style scoped src='./board.css'></style>


// WEBPACK FOOTER //
// src/pages/fr/5why/board.vue